'use strict';

console.log("old cookie banner");